import { Col, Row, Tooltip } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom';
import { useBoundStore } from '../../../../store/useBoundStore';
import moment from 'moment';
import { END_DATE, START_DATE } from '../../../../utils/Constants';

function UserActivitiesRow({ img = "", monthly_count, total_count, name, link, type_of_call, state, isAllBfiles, isGlobalDashboard = false, props }) {



  const queryParams = new URLSearchParams({
    title: encodeURIComponent(state.title || ""),
    call_type: encodeURIComponent(type_of_call || "review"),
    selected_card_type: encodeURIComponent(state.selected_card_type || ""),
  }).toString();


  const getSelectedDate = (location) => {
    const queryParams = new URLSearchParams(location);
    const allBfiles = queryParams.has("all_bfiles");
    const hasDates = queryParams.has("dates");


    const filters = useBoundStore.getState().AMDashboardFilter;

    if (isGlobalDashboard) {
      return { start_date: START_DATE, end_date: END_DATE };
    }

    if (filters.isDateRangeClicked) {
      const myDateObj = localStorage.getItem("dateObj");
      const parsedDateObj = JSON.parse(myDateObj);
      return {
        start_date: parsedDateObj && parsedDateObj.start_date || "2010-01-01",
        end_date: parsedDateObj && parsedDateObj.end_date || "2050-01-01"
      }
    }

    if (allBfiles) {
      return { start_date: START_DATE, end_date: END_DATE };
    } else if (hasDates) {
      const filters = useBoundStore.getState().AMDashboardFilter;
      return {
        start_date: filters.datemodified &&
          filters.start_date || "2010-01-01",
        end_date: filters.datemodified &&
          filters.end_date || "2050-01-01"
      }
    } else {
      const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
      const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");

      return {
        start_date: startOfMonth,
        end_date: endOfMonth
      };
    }
  };





  const handleClick = (e, type) => {
    e.preventDefault();

    useBoundStore.getState().resetFsFilters();


    const globalDashboardSource = isGlobalDashboard ? "&global_dashboard=true" : "";
    const search = type === 'total'
      ? `?all_bfiles&${queryParams}${globalDashboardSource}`
      : `?${queryParams}${globalDashboardSource}`;


    const selectedDateRange = getSelectedDate(search);
    const initialDateRange = {
      start_date: selectedDateRange.start_date,
      end_date: selectedDateRange.end_date,
    };

    useBoundStore.getState().setFsFilters({ datemodified: initialDateRange, filter_by_column_name: {} });


    props.history.push({
      pathname: link,
      search,
    });
  };

  // Direct container reference to override App.js configuration
  const getCustomContainer = () => document.body;

  return (
    <React.Fragment>
      <style>
        {`
          div.ant-tooltip {
            margin-top: -10px !important;
          }
        `}
      </style>
      <Row gutter={16} className='activites_card_row' style={{ marginLeft: 0, marginRight: 0 }}>
        <Col md={16}>
          {img && <img className='img' width={20} src={require(`../../../../assets/icons/dashboard/${img}.png`)} alt={name} />}
          <span className='name text-13 padding-left-10'>{name}</span>
        </Col>
        {isAllBfiles === true && (<Col md={4} style={{ textAlign: 'center' }}>
          <span className='count'>
            <Tooltip
              title={monthly_count}
              getPopupContainer={getCustomContainer}
              arrowPointAtCenter={true}
              placement="top"
            >
              <Link onClick={(e) => handleClick(e, 'monthly')} to="#">
                {monthly_count}
              </Link>
            </Tooltip></span>
        </Col>)}
        <Col md={4} style={{ textAlign: 'center' }}>
          <span className='count'>
            <Tooltip
              title={total_count}
              getPopupContainer={getCustomContainer}
              arrowPointAtCenter={true}
              placement="top"
            >
              <Link onClick={(e) => handleClick(e, 'total')} to="#">
                {total_count}
              </Link>
            </Tooltip>
          </span>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default UserActivitiesRow



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/EA_And_LSP/UserActivitiesRow.js